<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="users-settings-list">
                <div class="row marginBottom">
                    <div class="col-12">
                        <div class="col-3 peddingClassForAll peddingClassForAllLast">
                            <label class="container">All
                                <input type="checkbox" v-model="selectAll" @click="selectAllFunction">
                                <span class="checkmark"></span>
                            </label>
                        </div>
<!--                        <div class="col-3  peddingClassForAll">
                            User Limit
                        </div>-->
                    </div>
                </div>
                <div class="row">
                    <span v-for=" (client, index) in clientList" :id="client.id" v-if="clientList != null" :key="index">
                        <div class="col-12">
                            <div class="row item-wrap ">
                                <div class="col-3 line-item hovered-line list-group-item btn-visible">
                                    <div class="el user-item">
                                        <h3>{{ client.companyName }}</h3>
                                    </div>
                                </div>
                                <div class="col-3 line-item hovered-line list-group-item btn-visible">
                                    <span v-if="client.user">
                                        <div class="el email-item">
                                            <h3>{{ client.user.firstName + ' ' + client.user.lastName }}</h3> <br>
                                            <small>{{ client.user.title }}</small>
                                        </div>
                                    </span>
                                </div>
<!--                                <div class="col-3">
                                    <div class="md-layout-item" id="mydiv" ref="myid">
                                        <select name="LeaveType" @change="onChange($event,client.id)" class="form-control">
                                            <option v-if="client.user_count<=option" v-for="option in options" :key="option" :selected="option == client.user_limit" :value="option">{{ option }}</option>
                                        </select>
                                    </div>
                                </div>-->
                                <div class="col-3" style="float:right">
                                    <label class="container">
                                        <input type="checkbox" id="jack" :value="client.id" v-model="checkedNames">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </span>
                    <div class="row">
                        <div class="el logout-button">
                            <md-button @click="enableClientForInCoTour()">save</md-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <md-dialog :md-click-outside-to-close="false" :md-active.sync="showDialog">
            <div class="user-saving-message">
                <span>
                    <md-progress-spinner class="md-accent user-saving-spinner" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
                    Saving User(s) Details...
                </span>
            </div>
        </md-dialog>
    </section>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {enableClientForInCoTour} from '../../services/ClientService.js';

export default {
  data: () => ({
    checkedNames: [],
    selectAll: false,
    allClientId: [],
    showDialog: false,
    selected: 'A',
    country: null,
    options: [2, 3, 4, 5, 6, 7, 8, 9, 10],
    arrayForUserLimit: []
  }),
  computed: {
    ...mapGetters('client', ['clientList', 'currentClient'])
  },
  methods: {
    ...mapActions('client', ['loadClient']),
    async onChange (event, clientId) {
      this.arrayForUserLimit[clientId] = event.target.value;
    },
    async selectAllFunction () {
      this.checkedNames = [];
      if (!this.selectAll) {
        for (let i in this.clientList) {
          this.checkedNames.push(this.clientList[i].id);
        }
      }
    },
    async enableClientForInCoTour () {
      this.showDialog = true;
      await enableClientForInCoTour(this.checkedNames, this.allClientId, this.arrayForUserLimit);
      await this.loadClient({isAdmin: true, search: ''});
      this.showDialog = false;
    }
  },
  async mounted () {
    await this.loadClient({isAdmin: true, search: ''});
    for (let index = 0; index < this.clientList.length; index++) {
      if (this.clientList[index].compIncomStatus === 1) {
        this.checkedNames.push(this.clientList[index].id);
      }
      this.allClientId.push(this.clientList[index].id);
    }
  }
};
</script>

<style lang="scss" scoped>
.logout-button {
    padding-top: 13.5px;
    float: right;
}

.logout-button .md-button {
    color: white;
    background-color: #00A8CA;
    margin: 0;
}

.example-3 input[type=checkbox] {
    background: #999;
    height: 16px;
    width: 16px;
    display: inline-block;
    padding: 0 0 0 0px;
}

.example-3 input[type=checkbox]:checked {
    background: red;
    height: 16px;
    width: 16px;
    display: inline-block;
    padding: 0 0 0 0px;
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}

.container {
    padding: 0 64px;
    max-width: 1366px;
    margin: 0 auto;
}

.users-settings-list {
    padding: 32px;
}

.Usermanual-Tab {
    background-color: rgb(0, 168, 202);
    width: 100%;
    height: 39px;
}

.redActiveManual {
    border-bottom: 2px solid #08a8ca;

}

.fontManualTab {
    color: #08a8ca;
}

input.remove-no-file-chosen {
    width: 90px;
    color: #fff;
}

.showSelectedFile {
    padding-left: 0px !important;
    padding-top: 5px;
}

.full-btn {
    padding-right: 20px !important;
    padding-left: 10px !important;
}

.ManualBtn {
    display: inline-block !important;
    margin-bottom: 0 !important;
    font-weight: 400 !important;
    text-align: center !important;
    white-space: nowrap !important;
    vertical-align: middle !important;
    -ms-touch-action: manipulation !important;
    touch-action: manipulation !important;
    cursor: pointer !important;
    background-image: none !important;
    border: 1px solid transparent !important;
    padding: 6px 12px !important;
    font-size: 14px !important;
    line-height: 1.42857143 !important;
    border-radius: 4px !important;
    color: #fff !important;
}

.info-manual {
    font-size: 12px;
    margin-top: -20px;
    margin-bottom: -30px;
    overflow: hidden;
}

.ManualBtndelete {
    background-color: #d9534f !important;
}

.ManualBtncancel {
    color: white !important;
    background-color: #00a8ca !important;
    border-color: #ccc !important;
}

@media only screen and (max-width: 1024px) {
    .users-settings-list .line-item {
        display: flex;
        flex-flow: row nowrap;
    }

    .users-settings-list .line-item .left-item {
        display: flex;
    }
}

@media only screen and (max-width: 768px) {
    .users-settings-list .line-item .left-item {
        flex-flow: row wrap;
    }
    .el.email-item {
        padding-left: 10px;
    }
}

.boldContent {
    font-size: 19px;
}

.peddingClassForAll {
    float: right;
}

.peddingClassForAllLast {
    padding-left: 36px;
}

.marginBottom {
    margin-bottom: 20px;
}

/* The container */
.container {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 17px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 17px;
    width: 17px;
    background-color: #00A8CA;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
    background-color: #00A8CA;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
    background-color: #00A8CA;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
    left: 7px;
    top: 3px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
</style>





// WEBPACK FOOTER //
// src/components/settings/EnableIncompleteTours.vue